import PageTabs from "@/components/PageTabs/PageTabs";
import useIntercom from "@/hooks/useIntercom";
import useTranslation from "@/hooks/useTranslation";
import { QuestionCircleTwoTone } from "@ant-design/icons";
import { Space } from "antd";
import FakeLink from "../FakeLink/FakeLink";

export interface MaterialImpactPageTabProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
  showSuggestions?: boolean;
  showExioBase?: boolean;
}

export const tabItems = {
  suggestions: {
    key: "suggestions",
    label: "Suggestions",
  },
  all: {
    key: "all",
    label: "All",
  },
  ecoinvent: {
    key: "ecoinvent",
    label: "Ecoinvent",
  },
  agri_footprint: {
    key: "agri_footprint",
    label: "Agri-footprint",
  },
  exiobase: {
    key: "exiobase",
    label: "Exiobase",
  },
  root: {
    key: "root",
    label: "Root",
  },
  epd: {
    key: "epd",
    label: "EPD",
  },
  my_impact_references: {
    key: "custom",
    label: "Custom",
  },
};

export const ImpactReferencePageTabs = ({
  activeTab,
  setActiveTab,
  showSuggestions,
  showExioBase = false,
}: MaterialImpactPageTabProps) => {
  let items = Object.values(tabItems);

  if (!showSuggestions) {
    items = items.filter((item) => item.key !== tabItems.suggestions.key);
  }

  if (!showExioBase) {
    items = items.filter((item) => item.key !== tabItems.exiobase.key);
  }

  const t = useTranslation().impactReferenceModal;

  const onChange = (key: string) => {
    setActiveTab(key);
  };

  const { newMessage } = useIntercom();

  return (
    <>
      <PageTabs
        activeKey={activeTab}
        items={items}
        noLeftMargin={true}
        onChange={onChange}
        right={
          <Space>
            <QuestionCircleTwoTone />
            <span>{t.supportEmail.requestHelpText}</span>
            <FakeLink onClick={() => newMessage()}>{t.supportEmail.requestHelpButtonText}</FakeLink>
          </Space>
        }
      />
    </>
  );
};
